import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Panel,
  Table,
} from 'react-bootstrap';
import startCase from 'lodash/startCase';
import { withTranslation } from 'react-i18next';

class DeviceGroup extends Component {
  deleteDevice = deviceId => {
    const { deviceTypeName, onDelete } = this.props;
    onDelete(deviceId, deviceTypeName);
  };

  duplicateDevice = device => {
    const { deviceTypeName, onDuplicate } = this.props;
    onDuplicate(device, deviceTypeName);
  };

  newDevice = () => {
    const { deviceTypeName, onEdit } = this.props;
    onEdit(null, deviceTypeName);
  };

  editDevice = deviceId => {
    const { deviceTypeName, onEdit } = this.props;
    onEdit(deviceId, deviceTypeName);
  };

  renderDevice(device) {
    return (
      <tr key={device.id}>
        <td>{device.id}</td>
        <td>{device.description}</td>
        <td className="text-right">
          <a onClick={() => this.editDevice(device.id)}
            className="btn btn-default btn-action">
            <i className="fa fa-pencil"/>
          </a>
          <a onClick={() => this.deleteDevice(device.id)}
            className="btn btn-default btn-action">
            <i className="fa fa-remove"/>
          </a>
          <a onClick={() => this.duplicateDevice(device)}
            className="btn btn-default btn-action">
            <i className="fa fa-copy"/>
          </a>
        </td>
      </tr>
    );
  }

  render() {
    const { deviceTypeName, devices, t } = this.props;

    return (
      <Panel eventKey={deviceTypeName}>
        <Panel.Heading>
          <Panel.Title toggle className="btn-simple">
            {devices.length ? (
              <span className="device-no">({devices.length})</span>
            ) : ''}
            <i className="fa fa-angle-down"/>
            {t(startCase(deviceTypeName))}
          </Panel.Title>
          <a className="btn btn-sm btn-default btn-add" onClick={this.newDevice}>
            <i className="fa fa-plus" />
          </a>
        </Panel.Heading>
        <Panel.Body collapsible>
          {devices.length ? (
            <Table>
              <thead>
                <tr>
                  <th>{t('ID')}</th>
                  <th>{t('Name')}</th>
                  <th/>
                </tr>
              </thead>
              <tbody>{devices.map(d => this.renderDevice(d))}</tbody>
            </Table>
          ) : (
            <h5 className="text-center">
              <a onClick={this.newDevice}>{t('Add new')} {t(startCase(deviceTypeName))}</a>
            </h5>
          )}
        </Panel.Body>
      </Panel>
    );
  }
}

DeviceGroup.propTypes = {
  deviceTypeName: PropTypes.string.isRequired,
  devices: PropTypes.array.isRequired,
  onDelete: PropTypes.func.isRequired,
  onDuplicate: PropTypes.func.isRequired,
};

export default withTranslation()(DeviceGroup);
